import { cloneDeep } from 'lodash-es'
import { measureText } from '/@/components/BaseChart/utils'
import { multiplied } from '/@/utils/indicator'

// resize节流时间阈值（暂时只能为0, 调大了在频发变更时有可能导致获取高度失败）
export const ResizeThrottleTime = 0

// 基础11色
export const colors = [
  '#0D86FF',
  '#7AD5FF',
  '#F8CF53',
  '#EF8744',
  '#FF8FBE',
  '#66D8A9',
  '#FA9A95',
  '#5B8FFA',
  '#B3D591',
  '#7162FD',
  '#E03C7B',
  '#132CC9',
  '#D34339'
]

export const areaStyleColors = [
  '#0D86FF33',
  '#7AD5FF33',
  '#F8CF5333',
  '#EF874433',
  '#FF8FBE33',
  '#66D8A933',
  '#FA9A9533',
  '#5B8FFA33',
  '#ADEBD133',
  '#7162FD33',
  '#E03C7B33',
  '#132CC933',
  '#D3433933'
]

// 全局highLightColor
export const globalHighLightColor = '#EF8744'

// 完整20色
export const scatterColors = cloneDeep(colors)

export const scatterDefaultColor = scatterColors[0]

export const scatterHighlightColor = globalHighLightColor

export const scatterAreaTitleColors = '#132CC9'

// line-area 基础色
export const lineAreaColors = {
  primary: {
    line: '#0094FF',
    area: '#CCEAFF'
  },
  primaryLight: {
    line: '#7AD5FF',
    area: '#CCEAFF'
  },
  warning: {
    line: '#EF8744',
    area: '#FEF5DD'
  },
  warningLight: {
    line: '#F8CF53',
    area: '#F9E8DC'
  }
}

export const classifyColors = [ '#0094FF', '#F29F69', '#A364F5', '#469BA5' ]

export const generalGridStyle = {
  top: 16,
  right: 16,
  bottom: 16,
  left: 16,
  containLabel: true
}

/**
 * 横轴通用配置
 */
export const generalXAxisStyle = {
  // 坐标轴轴线
  axisLine: {
    lineStyle: {
      color: '#CDD0D6'
    }
  },
  // 坐标轴刻度
  axisTick: {
    alignWithLabel: true,
    length: 4,
    lineStyle: {
      color: '#CDD0D6'
    }
  },
  // 坐标轴分隔线
  splitLine: {
    show: false,
    lineStyle: {
      type: 'dashed',
      color: '#E4E7ED'
    }
  },
  // 坐标轴刻度标签
  axisLabel: {
    color: '#4E5255',
    margin: 8,
    fontSize: 12,
    lineHeight: 12
  },
  nameTextStyle: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'sans-serif',
    color: '#787A7D'
  }
}

/**
 * 主纵轴通用配置
 */
export const generalYAxisStyle = {
  // 坐标轴刻度标签
  axisLabel: {
    color: '#787A7D',
    margin: 8,
    fontSize: 12,
    lineHeight: 12,
    padding: [ 0, 0, 0, 0 ]
  },
  // 坐标轴分隔线
  splitLine: {
    lineStyle: {
      type: 'dashed',
      color: '#E4E7ED'
    }
  },
  // 坐标轴名称
  name: '',
  nameLocation: 'end',
  nameGap: 12,
  nameTextStyle: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'sans-serif',
    color: '#787A7D'
    // align: 'right',
    // padding: [ 0, -8, 0, 0 ]
  }
}

/**
 * 副纵轴通用配置
 */
export const generalMinorYAxisStyle = {
  ...generalYAxisStyle,
  // 坐标轴刻度标签
  axisLabel: {
    color: '#787A7D',
    margin: 8,
    fontSize: 12,
    lineHeight: 12,
    padding: [ 0, 0, 0, 0 ]
  },
  nameTextStyle: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'sans-serif',
    // align: 'right',
    padding: [ 0, 0, 0, -8 ]
  }
}

/**
 * 图例通用配置
 */
export const commonLegendStyle = {
  itemWidth: 12,
  itemHeight: 12,
  itemGap: 16,
  borderRadius: 0,
  inactiveBorderWidth: 'inherit',
  icon: 'rect',
  textStyle: {
    lineHeight: 12,
    fontSize: 12,
    rich: {
      a: {
        verticalAlign: 'middle'
      }
    },
    padding: [ -2, -2, -2, 4 ]
  },
  // 图例滚动
  type: 'scroll',
  pageIconSize: 10,
  pageTextStyle: {
    fontSize: 11,
    color: '#787A7D'
  },
  pageButtonGap: 8,
  pageButtonItemGap: 0,
  padding: [ 1, 16, 1, 16 ] // NOTICE: padding 设为0无法流畅触发事件，每个方向要保留至少1px
}

/**
 * 提示框通用配置
 */
export const tooltipGeneralConfig = {
  enterable: false,
  className: 'sino-tooltip-wrapper sino-tooltip-scrollbar'
}

export const baseTextGraphicStyle = {
  fill: '#787a7d',
  fontSize: 12,
  lineHeight: 20,
  fontWeight: 400,
  text: ''
}

export const baseTextGraphic = {
  type: 'text',
  style: { ...baseTextGraphicStyle }
}

export const radarGeneralConfig = {
  splitNumber: 4,
  axisName: {
    color: '#4E5255'
  },
  splitLine: {
    lineStyle: {
      width: 1,
      color: '#CDD0D6'
    }
  },
  splitArea: {
    show: false
  },
  axisLine: {
    lineStyle: {
      width: 1,
      color: '#E4E7ED'
    }
  }
}

export const legendIconWidthWithGap = 23 // legend icon宽度+gap
export const legendMaxWidth = 149 - legendIconWidthWithGap
export const legendFont = '12px sans-serif'
export const barMaxWidth = 56

export const legendIconRect = 'path://M2 2h8v8h-8z'
export const legendIconLine = 'path://M1.99707 4h7.9886v3h-7.9886z'
export const legendIconQuestion = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABEdJREFUaEPtWT1sFFcQ/mbPBhpQ6BPJpKAACRLhiAQJxZTpEgkacAEi6VIkgHxv17fm2XveexeQTZMqSCDxUyAh6OgSJ0I4loiAwkQpAieROomsFNHZuxPt2Zfc7e3evre+u8gSr7yb+Wa+N/PezJslbPFFW9x/vCbwf0ewZxGYkPJNazX8kMGjYIwANALwyDpBqgFcA6FGoMfhsPX9V1L+1gvymyJg23If09qnAB0BcNjQoSWAHxEPXa1U5HND3X/FcxGQUu76u752DqAvAezKa3xDbwXg+R3bhuaklCumWMYEhOOeBuECGPtNjXWVJyyDcVn53nUTXCMCwnGvAThtYiCH7HXle2d09bQJCMd9CUSHcyCrpnxvj44lLQJi0n0MxiEdwJ7JEH5Ss95oFl4mgaLtCiJUsoD68T8z7GrFU92wuxIoOu5JAm71wzldTAZOVX3vdpp8KoHGVbkaPDK9bQj4i4GbIPo2HLYWh+r1gC3rEIcYBeiiruMtF/3yjuHCkbQrNpWAcErS3CBPBxZuXCqXf01ytFH4rOCO6aYAPK38skzCTCSwXmGDRcMidVf53nGdHRaOGxF8W0e2WeyICx8kVexEAsVJd54YX+gaYOB3ClffU0q90NGxbfcoE37QkW3KMOFKddaLKn/bSibgTD0h8DvaBphvqUp5vFW+OOleoijvCWMW6HPfn/m69X9hl+6A6ISuDQY9rfoz72YSEEKOwAqioqW/iMYR1BebEbDtqbNMfLUVgAjnK7PeXPM3IUpjsOg7fSMAwsIepWStDTcO0Oh1gKhlMFpEWGHmGhg/g+ijzvPDD5VfPtoEnZiY2GkNbTdt3s7Ee6WOFDLNfwOWbe2Bbcu9TMEvBvpIOgedBBz3HgEfmwBryrbtXp4UYuB+1fc+6ZpCRdMDnOk9PySie635H6kIZ+oywOcz1VsEkg5yUgT+IOANE+BkWZ4mpgeVireU9L9w3Ch99prYYeDPqu/tzoiA2xsCIR9TqryQ6LzhFdrE0CRgWANStlD5Xkd0HUceCHmtZHL/t8LrplBPDnGcQKOwMS6YpExcVu8QG7YRaQ7FCQjH5c04H+lqXaNicuoUmG9u1lhf9InG1exM2/ukI08bA6p68KovDmwSNNxWeCs+EEts5oTj/phjUNXmXh9SaEn53vvxPUghUJrbGFrl3rPeE+B55ZfPaRHI+aDpZwRWjB4066U+z5PyPw69jYDhkzJyI++jPnfOpSkS8j3q16OQ723QYxIdb4CuvVDc+IDmoWmcM+ekmZO5jUgMci7aJKM1H9Ui0CAxyPmo5lw08kubQCQ8iDmpzjzU6AzEk7MxLyU45tO1jKNNWGaG320OmoRgFIEmwJb+xNS6C1HFDq3gMzCNGQ3CotYY9BTEC1ZY+GbgH/mSQrkxEBtjwsGun1kZzxAWFuIDqry1I1cK5TXWD73XBPqxqyaYWz4C/wBp0sZAUIv+hQAAAABJRU5ErkJggg=='

export const dataZoomWidth = 16 + 2 // 2px = border-left + border-right
export const dataZoomHeight = 16 + 2

export const dataZoomVerticalIcon = 'path://M0.5 9.5a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z'

export const dataZoomHorizontalIcon = dataZoomVerticalIcon // 'path://M2.09998 3.5a3 3 0 0 1 3 -3h5.800000000000001a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-5.800000000000001a3 3 0 0 1 -3 -3z'

export const dataZoomGeneralConfig = {
  showDataShadow: false,
  handleStyle: {
    borderColor: '#D4D7DE',
    color: '#FFF',
    borderWidth: 2
  },
  backgroundColor: '#F0F2F5',
  borderColor: 'transparent',
  borderRadius: 4,
  fillerColor: '#0D86FF1A'
}

export const dataZoomScrollbarConfig = {
  zoomLock: true,
  brushSelect: false,
  showDetail: false,
  type: 'slider',
  filterMode: 'empty'
}

export const dataZoomVerticalScrollConfig = {
  ...dataZoomScrollbarConfig,
  ...dataZoomGeneralConfig,
  handleIcon: dataZoomVerticalIcon,
  width: dataZoomWidth
}

export const dataZoomHorizontalScrollConfig = {
  ...dataZoomScrollbarConfig,
  ...dataZoomGeneralConfig,
  handleIcon: dataZoomHorizontalIcon,
  height: dataZoomHeight
}

export enum DataZoomRangePositionEnum {
  'LEFT' = 'left',
  'RIGHT' = 'right'
}

/**
 * 自定义tooltip position
 * canvas 实例渲染的canvas
 * point、params、dom、rect、size position原封不动的参数
 * @returns
 */
export type TooltipPosition = {
  renderContainer: HTMLElement
  point: [number, number]
  params: anyObj[]
  dom: HTMLElement
  rect: any
  size: {
    contentSize: [number, number]
    viewSize: [number, number]
  }
}

export const tooltipPosition = function ({
  renderContainer,
  point,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  params,
  dom,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  rect,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  size
}: TooltipPosition) {
  const gap = 10 // tooltip位置预留gap
  const { x: containerX, y: containerY } = renderContainer.getBoundingClientRect()
  const { width: tooltipWidth, height: tooltipHeight } = dom.getBoundingClientRect()
  const mouseX = point[0] + containerX
  const mouseY = point[1] + containerY
  // 默认位置，左上
  let tooltipY = point[1] - gap - tooltipHeight // 默认上边
  let tooltipX = point[0] + gap // 默认右边

  // 右边碰撞，移动到左边
  if (mouseX + gap + tooltipWidth > window.innerWidth) {
    const moveToLeftX = point[0] - gap - tooltipWidth
    // 移动到左边时左侧碰撞了
    if (gap + tooltipWidth > mouseX) {
      // 移动到居中位置
      const moveToCenter = point[0] - tooltipWidth / 2
      // 移动到居中位置时左边碰撞了
      if (tooltipWidth / 2 > mouseX) {
        const overflowX = tooltipWidth / 2 - mouseX
        tooltipX = moveToCenter + overflowX
      } else {
        // 移动到居中位置时右边碰撞了
        if (mouseX + tooltipWidth / 2 > window.innerWidth) {
          const overflowX = mouseX + tooltipWidth - window.innerWidth
          tooltipX = point[0] - overflowX
        } else {
          // 居中位置时左右都碰撞了，只能放到中间
          tooltipX = moveToCenter
        }
      }
    } else {
      tooltipX = moveToLeftX
    }
  }

  // 上边边碰撞，移动到下边
  if (mouseY < gap + tooltipHeight) {
    tooltipY = point[1] + gap
  }
  return [ tooltipX, tooltipY ]
}

export const axisOffset = 1.2 // 轴偏移系数

/**
 * axis 位置枚举
 */
export enum AxisPositionEnum {
  'Top' = 'top',
  'Bottom' = 'bottom',
  'Left' = 'left',
  'Right' = 'right',
}

/**
 * legend位置枚举
 */
export enum LegendPositionEnum {
  'Top' = 'top',
  'TopStart' = 'topStart',
  'TopEnd' = 'topEnd',
  'Bottom' = 'bottom',
  'BottomStart' = 'bottomStart',
  'BottomEnd' = 'bottomEnd',
  'Right' = 'right',
  'RightStart' = 'rightStart',
  'RightEnd' = 'rightEnd'
}

/**
 * 生成legendPosition
 * @param position
 */
export const generateLegendPosition = (
  position: LegendPositionEnum,
  config?: { showHorizontalDataZoom?: boolean }
): anyObj => {
  let formatPosition: anyObj = {}
  const { showHorizontalDataZoom } = config || {}
  const TopGap = 0
  // TOP
  if (position === LegendPositionEnum.Top) {
    formatPosition = {
      top: TopGap,
    }
  } else if (position === LegendPositionEnum.TopStart) {
    formatPosition = {
      top: TopGap,
      left: 0,
      right: 0
    }
  } else if (position === LegendPositionEnum.TopEnd) {
    formatPosition = {
      top: TopGap,
      right: 0
    }
  }

  // BOTTOM
  if (position === LegendPositionEnum.Bottom) {
    formatPosition = {
      bottom: 0
    }
  } else if (position === LegendPositionEnum.BottomStart) {
    formatPosition = {
      bottom: 0,
      left: 0,
      right: 0
    }
  } else if (position === LegendPositionEnum.BottomEnd) {
    formatPosition = {
      top: TopGap,
      right: 0
    }
  }

  // Right
  if (position === LegendPositionEnum.Right) {
    formatPosition = {
      top: 'middle',
      right: 0,
      orient: 'vertical'
    }
  } else if (position === LegendPositionEnum.RightStart) {
    formatPosition = {
      top: TopGap,
      right: 0,
      orient: 'vertical'
    }
  } else if (position === LegendPositionEnum.RightEnd) {
    formatPosition = {
      right: 0,
      bottom: showHorizontalDataZoom ? dataZoomHeight : 0,
      orient: 'vertical'
    }
  }

  return formatPosition
}

/**
 * 生成grid
 * @param echartsConfig
 */
export const generateGrid = (echartsConfig: anyObj, props: anyObj) => {
  const { legend = {} as anyObj, xAxis = {} as anyObj, yAxis = {} as anyObj } = echartsConfig
  const grid = { ...generalGridStyle, ...(props.gridConfig || {}) }
  const { containLabel = true } = grid

  const { show: legendVisible = true, textStyle: { lineHeight: legendHeight = 12 } = {} } = legend

  const xAxisVisible = xAxis.show ?? true
  const xAxisLabelVisible = xAxis?.axisLabel?.show ?? true

  const { axisLabel: { margin = 8, lineHeight: xAxisHeight = 12 } = {} } = xAxis
  const xAxisLabelHeight = margin + xAxisHeight

  const yAxisVisible = yAxis.show ?? true
  const yAxisLabelVisible = yAxis?.axisLabel?.show ?? true

  const existYAxisName = Boolean(yAxis.name)
  const { nameTextStyle: { fontSize = 12, lineHeight: yAxisHeight = 12, fontFamily = '' } = {}, name } = yAxis
  const yAxisFont = `${fontSize}px / ${yAxisHeight}px ${fontFamily}`
  const yAxisNameWidth = 0 ?? (existYAxisName ? Math.ceil(measureText(name || '', yAxisFont)) : 0)

  const legendGap = legendVisible ? legendHeight : 0
  const dataZoomGap = props.showDataZoom ? (props.legendPosition === LegendPositionEnum.Bottom ? 40 : 28) : 0

  let pos = {}
  if (containLabel) {
    pos = {
      bottom: grid.bottom,
      top: grid.top + (existYAxisName && yAxisVisible ? yAxisHeight : 0)
    }
  } else {
    pos = {
      bottom: grid.bottom + (xAxisVisible && xAxisLabelVisible ? xAxisLabelHeight : 0),
      top: grid.top + (existYAxisName && yAxisVisible ? yAxisHeight : 0),
      left:
        existYAxisName && yAxisVisible && yAxisLabelVisible
          ? Math.max(generalGridStyle.left, yAxisNameWidth) + 20 + margin
          : yAxisVisible && yAxisLabelVisible
            ? generalGridStyle.left + 20
            : generalGridStyle.left
    }
  }

  const baseGridStyle = { ...grid, ...pos }
  const baseConfig = {
    ...baseGridStyle,
    ...(props.legendPosition === LegendPositionEnum.Bottom
      ? { bottom: baseGridStyle.bottom + legendGap + dataZoomGap }
      : { top: baseGridStyle.top + legendGap + 12, bottom: (containLabel ? 0 : xAxisLabelHeight) + dataZoomGap })
  }
  const legendData = legend.data.map((item: any) => measureText(item.name, '12px'))
  legendData.sort((a: number, b: number) => b - a)

  if (legendVisible && props.legendPosition === LegendPositionEnum.Right) {
    baseConfig.right = (legendData[0] + 32 + 12) * 1.2
    baseConfig.top = 20
  }

  return {
    ...baseConfig
  }
}

/**
 * 生成y axis安全max
 */
export const generateYAxisSafeMax = (max: number, axisOffsetCoefficient?: number) => {
  let formatMax = max
  const formatAxisOffset = axisOffsetCoefficient !== undefined && axisOffsetCoefficient !== null ? axisOffsetCoefficient : axisOffset
  if (max > 0) {
    formatMax = multiplied(formatMax, formatAxisOffset)
  } else if (max < 0) {
    return formatMax / formatAxisOffset
  }
  return formatMax
}
// 给文本增加换行符
export const addLineBreaks = (str: string, splitNum = 5) => {
  return str.split('').reduce((acc, char, index) => {
    return acc + char + ((index + 1) % splitNum === 0 ? '\n' : '')
  }, '')
}
// 根据最大值计算分成N份最合理的间距
export const calculateStep = (maxValue: number, n: number): number => {
  // 动态生成步长数组
  const generateSteps = () => {
    const baseSteps = [ 0.1, 0.2, 0.5 ]
    let steps: number[] = []
    let multiplier = 1
    while (true) {
      const currentSteps = baseSteps.map(step => step * multiplier)
      const maxCurrentStep = currentSteps[currentSteps.length - 1]
      if (maxCurrentStep * n >= maxValue) {
        steps = steps.concat(currentSteps)
        break
      }
      steps = steps.concat(currentSteps)
      multiplier *= 10
    }
    return steps
  }

  const steps = generateSteps()
  let step = steps.find(s => maxValue <= s * n)
  if (!step) step = steps[steps.length - 1]
  return step
}

export enum ChartTypeEnum {
  '堆叠柱状图' = 'barStack',
  '分组柱状图' = 'barGroup'
}
